import {defaultStylesInline} from '@/constants/joditConfig'
import {words} from 'lodash'
import setTableDefaultStyle from '@/mixin/setTableDefaultStyle'
import createEmailTracker from '@/mixin/createEmailTracker'

export default {
  mixins: [setTableDefaultStyle, createEmailTracker],
  methods: {
    async createMimeMessage ({
      toName = '',
      toEmail,
      copy,
      copyHide,
      subject,
      contentHtml = '',
      userId,
      username = '',
      attachments,
      msgId,
      isDraft
    }) {
      const nl = '\r\n'
      const recipients = words(toEmail, /[^, |\s]+/g).map(item => '<' + item + '>')
      const html = this.setTableDefaultStyle(contentHtml)
      const location = window.location
      const port = (process.env.NODE_ENV === 'development' ? ':8080' : '')
      const hostname = `${location.protocol}//${location.hostname}${port}`
      const trackerId = isDraft ? '' : await this.createEmailTracker({messageId: userId})
      const imgSrc = trackerId.id ? `${hostname}/static/email/img/email_tracker.png?id=${trackerId.id}` : ''
      const imgTracker = `<img width="0" height="0" src='${imgSrc}' alt="">`
      const boundary = '__ctrlq_dot_org__'
      const mimeBody = [
        'Content-Type: multipart/mixed; boundary=' + boundary,
        'From: ' + username + ' <' + userId + '>',
        'To: ' + recipients,
        'Cc: ' + copy,
        'Bcc: ' + copyHide,
        'Subject: ' + `=?utf-8?B?${Buffer.from(subject).toString('base64')}?=` + nl,
        '--' + boundary,
        'Content-Type: text/html; charset=UTF-8',
        'MIME-Version: 1.0',
        'Content-Transfer-Encoding: 7bit' + nl,
        `<!DOCTYPE html>
         <html>
           <head>
           <meta http-equiv="Content-Type" content="text/html charset=UTF-8" />
            <style type="text/css">
              .ExternalClass {
                width: 100%;
              }
              .bb-email-link:hover {
                background-color: #F8F8F8 !important;
                border-top-color: #B9B9B9 !important;
                border-bottom-color: #B9B9B9 !important;
              }
            </style>
           </head>
           <body>
            <div style="${defaultStylesInline}">${html}${imgTracker}</div>
           </body>
         </html>`
      ]
      if (msgId) {
        const reply = [
          'In-Reply-To: ' + msgId,
          'References: ' + msgId,
          'Message-ID: ' + msgId
        ]
        mimeBody.unshift(reply.join(nl))
      }
      if (attachments) {
        attachments.forEach(file => {
          const index = +/base64,/.test(file.base64)
          const base64 = file.base64 ? file.base64.split('base64,')[index] : ''
          const attachment = [
            '--' + boundary,
            'Content-Type: ' + file.type + '; name="' + file.name + '"',
            'MIME-Version: 1.0',
            'Content-Disposition: attachment; filename="' + file.name + '"',
            'Content-Transfer-Encoding: base64' + nl,
            base64
          ]
          mimeBody.push(attachment.join(nl))
        })
      }
      mimeBody.push('--' + boundary + '--')
      return {
        content: mimeBody.join(nl),
        replyTo: msgId,
        trackerId: trackerId.id
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/createMimeMessage.js